import type { VorgangFilters } from '@/types/filters';

export const queryKeys = {
  vorgaenge: {
    all: ['vorgaenge'] as const,
    lists: () => [...queryKeys.vorgaenge.all, 'list'] as const,
    list: (
      filters?: VorgangFilters,
      pagination?: { page: number; pageSize: number },
      sorting?: { sortBy: string; sortOrder: 'asc' | 'desc' },
    ) =>
      [...queryKeys.vorgaenge.lists(), filters, pagination, sorting] as const,
    details: () => [...queryKeys.vorgaenge.all, 'detail'] as const,
    detail: (id: string) => [...queryKeys.vorgaenge.details(), id] as const,
    kommentare: (id: string) =>
      [...queryKeys.vorgaenge.all, 'kommentare', id] as const,
    statusClustering: () =>
      [...queryKeys.vorgaenge.all, 'statusClustering'] as const,
    alerting: () => [...queryKeys.vorgaenge.all, 'alerting'] as const,
  },

  archiv: {
    all: ['archiv'] as const,
    lists: () => [...queryKeys.archiv.all, 'list'] as const,
    list: (
      filters?: VorgangFilters,
      pagination?: { page: number; pageSize: number },
      sorting?: { sortBy: string; sortOrder: 'asc' | 'desc' },
    ) => [...queryKeys.archiv.lists(), filters, pagination, sorting] as const,
  },

  konfiguration: {
    all: ['konfiguration'] as const,
    datentransformationDebugSettings: () =>
      [
        ...queryKeys.konfiguration.all,
        'datentransformationDebugSettings',
      ] as const,
    eventDokumentTypMappings: () =>
      [...queryKeys.konfiguration.all, 'eventDokumentTypMappings'] as const,
    eventDokumentTypMappingByExternalId: (externalId: string) =>
      [
        ...queryKeys.konfiguration.all,
        `eventDokumentTypMappingByExternalId(${externalId})`,
      ] as const,
    eventDokumentTypMappingProtocolByExternalId: (externalId: string) =>
      [
        ...queryKeys.konfiguration.all,
        `eventDokumentTypMappingProtocolByExternalId(${externalId})`,
      ] as const,
    streamServeProjekte: () =>
      [...queryKeys.konfiguration.all, 'streamServeProjekte'] as const,
    streamServeProjektByExternalId: (externalId: string) =>
      [
        ...queryKeys.konfiguration.all,
        `streamServeProjektByExternalId(${externalId})`,
      ] as const,
  },

  mutations: {
    retryVorgang: (id: string) => ['mutation', 'retryVorgang', id] as const,
    saveVorgang: (id: string) => ['mutation', 'saveVorgang', id] as const,
    lockVorgang: (id: string) => ['mutation', 'lockVorgang', id] as const,
    unlockVorgang: (id: string) => ['mutation', 'unlockVorgang', id] as const,
    deleteVorgang: (id: string) => ['mutation', 'deleteVorgang', id] as const,
    restoreVorgang: (id: string) => ['mutation', 'restoreVorgang', id] as const,
  },
} as const;

export const getInvalidationKeys = (itemId?: string) => {
  const keys: (readonly string[])[] = [
    queryKeys.vorgaenge.all,
    queryKeys.archiv.all,
  ];

  if (itemId) {
    keys.push(queryKeys.vorgaenge.detail(itemId));
  }

  return keys;
};
